'use strict';

const _=require('pulsar-utils/dist-es6/_');let

GroupTreeExtensions=class GroupTreeExtensions{
constructor(groupTree){
this._groupTree=groupTree;
}

walkTreeFromRoot(fn,maxDepth){
_walkTreeFromRoot({children:this._groupTree},fn,void 0,void 0,maxDepth);
}

static extend(groupTree){
_.ensureInstanceOf([Object,Array],groupTree);

return new GroupTreeExtensions(_.toArray(groupTree));
}};


function _walkTreeFromRoot(group,fn,currentDepth=0,currentPath='',maxDepth=null){
fn(group,currentDepth,currentPath);

const nextDepth=currentDepth+1;
if(_.exists(maxDepth)&&nextDepth>MaxDepth){
return;
}

for(const[index,child]of group.children.entries()){
_walkTreeFromRoot(child,fn,nextDepth,currentPath+`${currentDepth>0?'.children.':''}${index}`,maxDepth);
}
}

module.exports=GroupTreeExtensions.extend;
//# sourceMappingURL=groupTreeExtensions.js.map
